exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".configTable .ant-table-thead tr th:nth-child(1) {\n  width: 253px;\n}\n.configTable .ant-table-thead tr th:nth-child(2) {\n  width: 300px;\n}\n.configTable .ant-table-thead tr th:nth-child(3) {\n  width: 370px;\n}\n.configTable .ant-table-thead tr th:nth-child(4) {\n  width: 0;\n  min-width: 0;\n  max-width: 0;\n  padding: 0 !important;\n}\n.configTable .ant-table-body tr td:nth-child(1) {\n  width: 253px;\n}\n.configTable .ant-table-body tr td:nth-child(2) {\n  width: 300px;\n}\n.configTable .ant-table-body tr td:nth-child(3) {\n  width: 370px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/stubParamsConfig.styl
// module id = 4454
// module chunks = 0